import React, { useState } from "react";

import { FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { rowSelected, snackbarData, userCredentials } from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { horarioRangoIns } from "services/services-mia/miakey";
import { Box, FormLabel, ToggleButton, ToggleButtonGroup } from "@mui/material";

const DIAS = [
    { cod: "LU", label: "Lu" },
    { cod: "MA", label: "Ma" },
    { cod: "MI", label: "Mi" },
    { cod: "JU", label: "Ju" },
    { cod: "VI", label: "Vi" },
    { cod: "SA", label: "Sa" },
    { cod: "DO", label: "Do" },
];

export default function InsertModal({ updateList, horarioId, closeModal }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);
    const [diasSeleccionados, setDiasSeleccionados] = useState([]);

    const handleDiasChange = (_, newDias) => {
        setDiasSeleccionados(newDias);
    };

    const handleSubmit = async ({ entrada, salida }) => {
        if (diasSeleccionados.length === 0) {
            setSnackbarInfo({ message: "Seleccione al menos un día", severity: "error", open: true });
            return;
        }

        setInRequest(true);

        const response = await horarioRangoIns({
            gateHorarioId: horarioId,
            gateHorarioRangoDias: diasSeleccionados.join(","),
            gateHorarioRangoEntrada: entrada,
            gateHorarioRangoSalida: salida,
        }, credentials);

        const functions = {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        };

        handleResponse(response, "Rangos Horarios agregados exitosamente", functions);

        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{
                entrada: "09:00",
                salida: "18:00",
            }}
            validationSchema={yup.object({
                entrada: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required),
                salida: yup.string(FORM_ERROR_MESSAGES.text).required(FORM_ERROR_MESSAGES.required),
            })}
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit(values);
                } catch (e) {
                    setSnackbarInfo({ message: e.errmsg, severity: "error", open: true });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column-sm"]}>
                    <Box display="flex" flexDirection="column" gap="4px" width="100%">
                        <FormLabel>Días</FormLabel>
                        <ToggleButtonGroup
                            value={diasSeleccionados}
                            onChange={handleDiasChange}
                            aria-label="días de la semana"
                            sx={{
                                flexWrap: "wrap",
                                gap: "6px",
                                width: "100%",
                                "& .MuiToggleButton-root": {
                                    flex: 1,
                                    padding: "8px 12px",
                                    fontSize: "0.95rem",
                                    border: "1px solid rgba(0,0,0,0.23) !important",
                                    borderRadius: "4px !important",
                                    color: "rgba(0,0,0,0.6)",
                                },
                                "& .MuiToggleButton-root.Mui-selected": {
                                    backgroundColor: "#FF6D00",
                                    color: "#fff",
                                    borderColor: "#FF6D00 !important",
                                    "&:hover": { backgroundColor: "#e65100" },
                                },
                            }}
                        >
                            {DIAS.map(({ cod, label }) => (
                                <ToggleButton key={cod} value={cod} aria-label={label}>
                                    {label}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </Box>
                    <Box display="flex" flexDirection="row" gap="20px" width="100%">
                        <FormikTextInput fullWidth name="entrada" labelText="Entrada" type="time" />
                        <FormikTextInput fullWidth name="salida" labelText="Salida" type="time" />
                    </Box>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Agregar" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
